import React from 'react'
import { formatDate, defaultDateTimeFormat } from '@/utils/dateUtilities'
import Icon from '@/components/Icon'
import CommentInput from '@/components/comments/CommentInput'

export const visibilityTypes = {
  INTERNAL: 0,
  EXTERNAL: 1
}

class CommentItem extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      showInput: false
    }
  }
  renderUserType () {
    const { localize, visibility } = this.props
    return visibility === visibilityTypes.EXTERNAL ? localize('Common.External') : localize('Common.Internal')
  }

    toggle = (e) => {
      e.preventDefault()
      this.setState({
        showInput: !this.state.showInput
      })
    }

    render () {
      const { author, creationTime, answers, text, localize, onCommentCreated, disabled, showExternalVisibilityCheckbox } = this.props
      return (
        <div className='comment'>
          <div className='comment__top metadata'>
            <div className='comment__author'><span>{author}</span> <small>• {this.renderUserType()}</small></div>
            <time>{formatDate(creationTime, defaultDateTimeFormat)}</time>
          </div>
          <div className='comment__text-wrap'>
            <div className='comment__text' dangerouslySetInnerHTML={{ __html: text }} />
            {(this.props.parentId === null || this.props.parentId === undefined) && disabled !== true &&
            <button disabled={disabled} className='btn-icon comment__answer' onClick={this.toggle}><Icon name='reply' /></button> }
          </div>
          {this.state.showInput && <CommentInput disabled={disabled} showExternalVisibilityCheckbox={showExternalVisibilityCheckbox} onCommentCreated={onCommentCreated} parentId={this.props.id} />}

          <div className='comment comment--reply'>
            {(answers || []).map((comment, index) => <CommentItem
              key={index}
              {...comment}
              showExternalVisibilityCheckbox={showExternalVisibilityCheckbox}
              onCommentCreated={onCommentCreated}
              localize={localize} />)}
          </div>
        </div>
      )
    }
}

export default CommentItem



// WEBPACK FOOTER //
// ./src/components/comments/CommentItem.js